import { render, staticRenderFns } from "./DeleteFtpUserDialog.vue?vue&type=template&id=6509b344&"
import script from "./DeleteFtpUserDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteFtpUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports